import { ApiProperty } from "@nestjs/swagger";

export class PlantsIdRequest{
    @ApiProperty()
    plantId:number;
}